import React, { useState, useEffect, useRef } from "react";
import { CarouselProvider, Slider, Slide, Dot, Image, ButtonBack, ButtonNext } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { fiberzymeImage, cfsblockImage, opticmindImage, feminacurveImage } from "./image";
import { data } from "./data";
import { Link } from "react-router-dom";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import CancelIcon from '@mui/icons-material/Cancel';
import ArtTrackIcon from "@mui/icons-material/ArtTrack";
import shopeeLogo from "../assets/shopee-logo.jpg";
import lazadaLogo from "../assets/lazada-logo.jpg";
import whatsappLogo from "../assets/whatsapp-logo.jpg";
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const [productImage, setProductImage] = useState(fiberzymeImage);
  const [product, setProduct] = useState("fiberzyme");
  const [descriptionLanguage, setDescriptionLanguage] = useState("EN");
  const [descriptionContent, setDescriptionContent] = useState();
  const [render, setRender] = useState(true);
  const [shopeeLink, setShopeeLink] = useState("https://shopee.com.my/product/310553724/5865596123/");
  const [lazadaLink, setLazadaLink] = useState("https://www.lazada.com.my/products/ezsense-fiberzyme-grape-detox-enzyme-fiber-gut-health-i3200225209-s16239334516.html");

  // ----------------- change description content --------------------------------------------
  
  useEffect(() => {
    setDescriptionContent(data[product][descriptionLanguage]);
  }, [product, descriptionLanguage]);

  // ----------------- re-render images when changing product----------------------------------

  useEffect(() => {
    setRender(false);
    setTimeout(() => {
      setRender(true);
    }, 10);
  }, [product]);

  // ----------------- show full Image -------------------------------------------------------

  const [showImage, setShowImage] = useState(false);
  const imageRef = useRef(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // change url with query enable us to click back without change the base url
  const navigate = useNavigate();
  const handleClick = ()=>{
    setShowImage(true);
    setCurrentImageIndex(imageRef.current.state.currentSlide)
    navigate('/?query=enlargeImage'); 
  }

  // when back button of the browser is clicked
  window.addEventListener('popstate',()=>{
    setShowImage(false);
  });

  const handleClose = ()=>{
    setShowImage(false);
  }

  // fake back button on full screen
  const handleFakeBack = ()=>{
    const realBack = document.querySelector(".real-back")
    realBack.click()
    // the click does not change the state immediately, 
    // so we need a delay function, so that it runs after the state has been updated.
    setTimeout(() => {
      setCurrentImageIndex(imageRef.current.state.currentSlide);
    }, 0);
  }

  // fake next button on full screen
  const handleFakeNext = ()=>{
    const realNext = document.querySelector(".real-next")
    realNext.click()
    setTimeout(() => {
      setCurrentImageIndex(imageRef.current.state.currentSlide);
    }, 0);
  }
  
  // change the image display in full screen
  useEffect(() => {
    const currentImageFull = document.querySelector(".current-image-full");
    if (currentImageFull) {
      currentImageFull.src = productImage[currentImageIndex]
    }
  }, [currentImageIndex, productImage]);

  document.addEventListener('touchend', ()=>{
    if(imageRef.current){
      setCurrentImageIndex(imageRef.current.state.currentSlide)
    }
  })

  // ----------------- // -------------------------------------------------------

  const [carouselWidth, setCarouselWidth] = useState();
  const [carouselHeight, setCarouselHeight] = useState();

  useEffect(() => {
    
  const carouselWidth = document.querySelector('.carousel-wrapper').clientWidth
  setCarouselWidth(carouselWidth);
  const carouselHeight = document.querySelector('.carousel-wrapper').clientHeight
  setCarouselHeight (carouselHeight)
    
  }, []);

  return (
    <div className="home">
    {/* ---------------------full screen image-------------------------------------- */}
      {showImage && (
        <div class="modal-row">
          <div className="close-wrapper">
          <CancelIcon onClick={handleClose}
              className="cancel-icon"
            />          
            </div>
       
          <div class="modal-content">
            <img
              src={productImage[currentImageIndex]}
              alt="img"
              className="current-image-full"
            />
          </div>
          <div className="fake-back-wrapper" onClick={handleFakeBack}>
            <KeyboardDoubleArrowLeftIcon
              className="fake-back"
              
            />
          </div>
          <div className="fake-next-wrapper" onClick={handleFakeNext}>
            <KeyboardDoubleArrowRightIcon
              className="fake-next"
              
            />
          </div>
        </div>
      )}
      {/* --------------------- product btn -------------------------------------- */}

      <div className="product-btn-wrapper">
        <Link
          className="product-btn"
          style={product === "fiberzyme" ? { color: "#9a4eae" } : {}}
          onClick={() => {
            setProduct("fiberzyme");
            setProductImage(fiberzymeImage);
            setShopeeLink(
              "https://shopee.com.my/product/310553724/5865596123/"
            );
            setLazadaLink(
              "https://www.lazada.com.my/products/ezsense-fiberzyme-grape-detox-enzyme-fiber-gut-health-i3200225209-s16239334516.html"
            );
          }}
        >
          <div className="icon-wrapper">
            <ArtTrackIcon />
          </div>
          Ezsense Fiberzyme
        </Link>
        <Link
          className="product-btn"
          style={product === "cfsblock" ? { color: "#9a4eae" } : {}}
          onClick={() => {
            setProduct("cfsblock");
            setProductImage(cfsblockImage);
            setShopeeLink(
              "https://shopee.com.my/product/310553724/21090156628/"
            );
            setLazadaLink(
              "https://www.lazada.com.my/products/ezsense-cfsblock-carbohydrates-blocker-fat-blocker-fat-burner-sugar-blocker-i3691252414-s20924048283.html"
            );
          }}
        >
          <div className="icon-wrapper">
            <ArtTrackIcon />
          </div>
          Ezsense CFSblock
        </Link>
        <Link
          className="product-btn"
          style={product === "opticmind" ? { color: "#9a4eae" } : {}}
          onClick={() => {
            setProduct("opticmind");
            setProductImage(opticmindImage);
            setShopeeLink(
              "https://shopee.com.my/product/310553724/10099811773/"
            );
            setLazadaLink(
              "https://www.lazada.com.my/products/ezsense-opticmind-eye-brain-health-lutein-zeaxanthin-bilberry-bacopa-ginkgo-i3691372267-s20924375701.html"
            );
          }}
        >
          <div className="icon-wrapper">
            <ArtTrackIcon />
          </div>
          Ezsense OpticMind
        </Link>
        <Link
          className="product-btn"
          style={product === "feminacurve" ? { color: "#9a4eae" } : {}}
          onClick={() => {
            setProduct("feminacurve");
            setProductImage(feminacurveImage);
            setShopeeLink(
              "https://shopee.com.my/product/310553724/15999368833/"
            );
            setLazadaLink(
              "https://www.lazada.com.my/products/ezsense-feminacurve-women-health-menstruation-health-i3777810630-s21672826160.html"
            );
          }}
        >
          <div className="icon-wrapper">
            <ArtTrackIcon />
          </div>
          Ezsense FeminaCurve
        </Link>
      </div>
      {/* --------------------- product carousel -------------------------------------- */}

      <div className="carousel-wrapper">
        {!render &&(<div style={{width:`${carouselWidth}px`, height:`${carouselHeight}px`, backgroundColor:'white'}}></div>)}
        {render && (
          <CarouselProvider
            naturalSlideWidth={20}
            naturalSlideHeight={20}
            orientation="horizontal"
            hasMasterSpinner="true"
            interval="5000"
            isPlaying="true"
            totalSlides={productImage.length}
          >
            <Slider>
              <div className="slider-top-space"></div>
              {productImage.map((image, index) => (
                  <Slide index={index} key={index} ref={imageRef}>
                    <img
                      onClick={handleClick}
                      className="d-block w-100 product-card-image"
                      src={image}
                      alt='product-info-and-review'
                    />

                    <ButtonBack className="real-back">
                      <KeyboardDoubleArrowLeftIcon />
                    </ButtonBack>
                    <ButtonNext className="real-next">
                      <KeyboardDoubleArrowRightIcon />
                    </ButtonNext>
                  </Slide>
                ))}
            </Slider>

            <div className="all-dots">
              {productImage.map((image, index) => (
                  <Dot slide={index} key={index}>
                    <Image
                      className="d-block w-100 product-card-image image-choice"
                      src={image}
                    />
                  </Dot>
                ))}
            </div>
          </CarouselProvider>
        )}
      </div>
      {/* --------------------- description -------------------------------------- */}

      <div className="desc-wrapper">
        <div className="description-option">
          <p className="description-option-text">DESCRIPTION</p><p className="description-option-semicolon">:</p>
          <Link
            className="description-option-btn"
            style={descriptionLanguage === "EN" ? { color: "#9a4eae" } : {}}
            onClick={() => {
              setDescriptionLanguage("EN");
            }}
          >
            ENG
          </Link>
          <Link
            className="description-option-btn"
            style={descriptionLanguage === "CN" ? { color: "#9a4eae" } : {}}
            onClick={() => {
              setDescriptionLanguage("CN");
            }}
          >
            中文
          </Link>
        </div>
        <div className="ecommerce-option">
          <p className="description-option-text">E-COMMERCE</p><p className="description-option-semicolon">:</p>
          <Link className="shopee-wrapper" to={shopeeLink} target="_blank">
            <img src={shopeeLogo} alt='shopee-logo'></img>
          </Link>
          <Link className="shopee-wrapper" to={lazadaLink} target="_blank">
            <img src={lazadaLogo} alt='lazada-logo'></img>
          </Link>
        </div>

        <div className="description-content">
          {descriptionContent &&
            descriptionContent.map((desc) => {
              if (desc === " ") {
                return <div className="empty-line"></div>;
              } else {
                return <h6 className="text-line">{desc}</h6>;
              }
            })}
          {descriptionLanguage === "EN" && (
            <div>
              <p className="wholesale-text">
                To find out more about our wholesale price,{" "}
              </p>
              <Link
                className="whatsapp-wrapper"
                to="https://wa.link/ey3e49"
                target="_blank"
              >
                contact us.<img src={whatsappLogo} alt='whatsapp-logo'></img>
              </Link>
            </div>
          )}
          {descriptionLanguage === "CN" && (
            <div>
              <p className="wholesale-text">若想要了解更多关于我们的批发价, </p>
              <Link
                className="whatsapp-wrapper"
                to="https://wa.link/ojxrs1"
                target="_blank"
              >
                请联系我们。<img src={whatsappLogo} alt='whatsapp-logo'></img>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
